import styled from 'styled-components';

const ManualPriceWarningStyles = (Component) => styled(Component)`
  width: 352px;
  border-radius: 4px;
  border: solid 1px var(--accent900);
  padding: 16px;
  color: var(--accent900);
  background-color: var(--accent100);

  .title {
    font-weight: bold;
  }

  .description {
    margin-top: 6px;
  }

  .extra {
    font-weight: bold;
  }
`;

export default ManualPriceWarningStyles;
